export default {
  KPI_TYPE: { id: 'kpi', name: 'KPI', panelType: 'assurance-kpi-panel' },
  TREND_TYPE: { id: 'trend', name: 'Trend', panelType: 'assurance-trend-panel' },
  DATASET_TYPE: { id: 'dataset', name: 'Dataset', panelType: 'assurance-top-list-panel' },
  getPanelOptions: function(params, isTopListPanel = false) {
    let self = this;
    let panelOptions = {};
    if (isTopListPanel || params.datasetName) {
      panelOptions = {
        type: 'assurance-top-list-panel',
        height: 6,
        width: 2
      }
    } else if (params.analysisId === self.KPI_TYPE.id) {
      panelOptions = {
        type: self.KPI_TYPE.panelType,
        height: params.isPercentage ? 4 : 2,
        width: 1
      };
    } else if (params.analysisId === self.TREND_TYPE.id) {
      panelOptions = {
        type: self.TREND_TYPE.panelType,
        height: 6,
        width: 2
      };
    }
    return panelOptions;
  }
}